import { ServerContextState } from "./redux/slices/serverContext";
import { AppDispatch, GetAppState } from "./redux/store";
import { isBaseline, isUS } from "./userSegment";
import { Plan } from "src/utils/redux/slices/plans";
import saveToBraze from "./brazeUploader";
import { RecommendedPlanState } from "./redux/slices/recommendedPlan";

export const HM_CURRICULUM = "HM";
export const VIP_HM_CURRICULUM = "VIP_HM";

export function getDefaultTrialFee(serverContext: ServerContextState) {
  if (serverContext.choose_trial_fee && serverContext.trial_fees) {
    const rawFee = Math.min(...serverContext.trial_fees);
    return rawFee < 1 && rawFee > 0 ? +rawFee.toFixed(2) : rawFee;
  }
  return 0;
}

/**
 * Determine if user eligible for 7 day trial.
 */
export function has7DayTrial() {
  if (isUS() && isBaseline()) {
    return true;
  }
  return false;
}

/**
 * Determine the length of user's trial for in trial users
 */
export function getTrialLength(serverContext: ServerContextState) {
  const subscriptions = JSON.parse(serverContext.subscriptions);
  const subscription = subscriptions.find((sub) => sub.status === "ACTIVE");
  if (subscription) {
    if (/32_day/.test(subscription.plan_id)) {
      return 32;
    }
    if (/22_day/.test(subscription.plan_id)) {
      return 22;
    }
    if (/8_day/.test(subscription.plan_id)) {
      return 8;
    }
  }
  return 15;
}

/**
 * Determine whether a plan is part of the HM curriculum
 */
export function isHMPlan(plan: Partial<Plan>) {
  return [HM_CURRICULUM, VIP_HM_CURRICULUM].includes(plan.curriculum);
}

export function savePlanToBraze(data: {
  recommendedPlan: RecommendedPlanState;
  currentBMI: string;
  targetBMI: string;
  targetMonthNameFull: string;
}) {
  return (dispatch: AppDispatch, getState: GetAppState) => {
    const { plans, userData } = getState();
    let recommendedPlan: RecommendedPlanState;

    switch (data.recommendedPlan.trial_duration) {
      case 0:
      case 14:
        ({ recommendedPlan } = data);
        break;
      default:
        recommendedPlan = plans[data.recommendedPlan.billing_cycle_in_months];
    }

    const recommendedPlan7Days =
      plans[`${data.recommendedPlan.billing_cycle_in_months}-7-DAY-TRIAL`];
    const properties: JsonObject = {
      current_bmi: data.currentBMI,
      target_bmi: data.targetBMI,
      recommended_month_goal: data.targetMonthNameFull,
      recommended_plan_url: recommendedPlan.noom_plan_id,
      recommended_plan_regular_price: recommendedPlan.formatted_regular_price,
      recommended_plan_regular_monthly_price:
        recommendedPlan.formatted_regular_monthly_price,
      recommended_plan_price: recommendedPlan.formatted_price,
      recommended_plan_monthly_price: recommendedPlan.formatted_monthly_price,
      recommended_plan_duration: recommendedPlan.billing_cycle_in_months,
    };
    if (recommendedPlan7Days) {
      properties.recommended_plan_url_7day = recommendedPlan7Days.noom_plan_id;
    }
    const forcedNoomPlanId = new URLSearchParams(window.location.search).get(
      "noom_plan_id"
    );
    if (forcedNoomPlanId) {
      properties.forcedNoomPlanId = forcedNoomPlanId;
    }

    if (recommendedPlan.starter_fee) {
      properties.recommended_plan_starter_fee = `${recommendedPlan.currency_symbol}${recommendedPlan.starter_fee}`;
    }
    saveToBraze(userData.user_id, properties, null);
  };
}
